import React, { useState, useEffect } from "react";
import "./Header.css";
import { HiMenuAlt3 } from "react-icons/hi";
import logoImg from "../../img/logo.jpeg";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory(); // For v5 navigation

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleResize = () => {
    // Close menu if window is resized above 768px
    if (window.innerWidth > 768) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="logos">
          <a className="logoImg">

            <img src={logoImg} alt="logo" />
          </a>
          <h1>Sageion</h1>
        </div>
        <button className="navbar-toggler" onClick={toggleMenu}>
          ☰
        </button>
        <div className={`navbar-menu ${isOpen ? "open" : ""}`}>
          <ul>
            {/* <li>Home</li>
            <li>About</li> */}
            <li>
              <a
                href="https://sageion.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="navLink"
              >
                Services
              </a>
            </li>
          </ul>
          <div className="navbar-buttons">
            <button
              className="btns signup_btn"
              onClick={() => history.push("/signup")}
            >
              Sign-up
            </button>
            <Link to="/schedule_demo">
              <button className="btns demo">Schedule a demo</button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};
